export default __webpack_public_path__ + "static/media/icons8-ok.3c8e7cf4.svg";